import { sanitize } from '../utils/sanitizeText'
import { sendEvent, getURL, baseInteraction } from './utils'

export const TagPushCart = {
    interactionAddMoreProducts: (url) => {
        let event = {
            event: 'interaction',
            element_type: `select:link:click`,
            element_content: `none:adicionar-mais-produtos:none`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:minha-cesta:home',
            screen_type: 'modal',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    beginCheckout: (products = []) => {
        let items = []
        if (products.length > 0) {
            items = products.map((product) => ({
                item_name: sanitize(product.name),
                item_id: product.code,
                price: product.value,
                item_brand: 'alelo',
                item_category: 'cartoes',
                quantity: product.quantity
            }))
        }

        let event = {
            event: 'begin_checkout',
            ecommerce: { items }
        }
        sendEvent(event)
    },
    removeFromCart: (product) => {
        let item = {}
        if (product) {
            item = {
                item_name: sanitize(product.name),
                item_id: product.code,
                price: product.value,
                item_brand: 'alelo',
                item_category: 'cartoes',
                quantity: product.quantity
            }
        }

        let event = {
            event: 'remove_from_cart',
            ecommerce: {
                items: [item]
            }
        }
        sendEvent(event)
    }
}
